export default function ContactFooter() {
  return (
    <footer className="w-full bg-background-200/80 relative overflow-hidden" aria-labelledby="contact-heading">
      {/* Decorative edge rectangles */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-3 h-32 bg-foreground-800/10 rotate-12 hidden lg:block" aria-hidden="true"></div>
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-3 h-32 bg-foreground-800/10 -rotate-12 hidden lg:block" aria-hidden="true"></div>

      <div className="max-w-6xl mx-auto px-10 md:px-16 lg:px-20 py-16 md:py-20">
        {/* Main contact card */}
        <div className="bg-background-50 rounded-[32px] px-10 md:px-14 py-14 md:py-16 flex flex-col lg:flex-row gap-12 lg:gap-0">
          {/* Left brand block */}
          <div className="lg:w-1/4">
            {/* Minimal geometric brand mark */}
            <div className="w-8 h-8 relative" aria-hidden="true">
              <div className="absolute inset-0 border-2 border-foreground-800 rounded-sm rotate-45"></div>
              <div className="absolute inset-1.5 bg-foreground-800 rounded-sm rotate-45"></div>
            </div>
            <p className="mt-6 text-sm text-foreground-500 font-body font-light leading-relaxed max-w-[200px]">
              Professional engineering team focused on modern digital solutions for the iOS platform.
            </p>
          </div>

          {/* Three contact columns */}
          <div className="lg:w-3/4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-8">
            {/* Address */}
            <div>
              <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.15em] text-foreground-400 mb-5">
                <span className="text-foreground-800">Location</span>
              </h4>
              <address className="not-italic text-sm text-foreground-600 font-body font-light leading-relaxed">
                <p>226 Ogden St</p>
                <p>Thunder Bay</p>
                <p>P7C 2N1</p>
                <p>Canada</p>
              </address>
            </div>

            {/* Phone */}
            <div>
              <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.15em] text-foreground-400 mb-5">
                <span className="text-foreground-800">Phone</span>
              </h4>
              <p className="text-sm text-foreground-600 font-body font-light leading-relaxed">
                +1 2494448687
              </p>
            </div>

            {/* Email */}
            <div>
              <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.15em] text-foreground-400 mb-5">
                <span className="text-foreground-800">Email</span>
              </h4>
              <p className="text-sm text-foreground-600 font-body font-light leading-relaxed break-all">
                info@sivoraaspps.com
              </p>
            </div>
          </div>
        </div>

        {/* Copyright bar */}
        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400 font-body font-light">
            &copy; {new Date().getFullYear()} Sivora Apps LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-3" aria-hidden="true">
            <span className="w-2 h-2 rounded-full bg-foreground-300"></span>
            <span className="w-2 h-2 bg-foreground-300"></span>
          </div>
        </div>
      </div>
    </footer>
  );
}